<template>
	<div class="width-100 display-flex flex-row">
		<div
			v-for="(panel, i) in panels"
			@click="$emit('tab-clicked', i)"
			:key="panel.title"
			class="display-flex flex-row flex-align-center flex-justify-space-between flex-1 left-button tab-button"
			:class="{
				'right-button': i === 1,
				active: openedPanelIndex === i,
				'only-button': panels.length === 1,
				'flex-centerize': !isPanelNotValid(panel),
			}"
		>
			<div v-if="isPanelNotValid(panel)" class="placeholder-container" />
			<!-- This is a placeholder container to align with space between of the errror icon. Do not deletes -->
			<div class="display-flex flex-column flex-centerize">
				<div class="tab-title">{{ panel.title }}</div>
				<div class="tab-description display-flex flex-row flex-align-center">
					{{ panel.description }}
					<AppTooltip position="bottom" :text="panel.tooltipDescription">
						<SIcon class="info-icon ml-1" name="installation-tab-info" width="12" height="12" />
					</AppTooltip>
				</div>
			</div>
			<SIcon v-if="isPanelNotValid(panel)" class="icon-container" name="configuration-error" />
		</div>
	</div>
</template>
<script>
export default {
	name: 'EditConfigurationTabs',
	props: {
		panels: { type: Array },
		openedPanelIndex: { type: Number },
		installationMode: { type: Boolean },
		showErrorMessage: { type: Boolean },
		didUserTriedToSaveOnce: { type: Boolean },
		notValidConfigurationsIds: { type: Array },
	},
	computed: {},
	methods: {
		isPanelNotValid(panel) {
			return this.notValidConfigurationsIds.includes(Number(panel.configurationId)) && this.didUserTriedToSaveOnce;
		},
	},
	data() {
		return {};
	},
};
</script>
<style scoped lang="scss">
.tabs-container {
	background: var(--setup-node-container-background);
}
.tab-button {
	height: 45px;
	cursor: pointer;
	padding: 0px 10px;
	background: var(--bg-color);
	border: 1px solid #d4d8dd;

	font-size: 14px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);

	&:hover {
		background: #f2f2f2;
		&.active {
			background: #c9d3e7;
		}
	}

	&.active {
		background: #ebf1fd;
		border-color: #5f8ef0;
		box-shadow: 0px 3px 6px #00000029;
		.tab-title {
			font-weight: bold;
			color: var(--primary-font-color);
		}
	}
}
.left-button {
	border-radius: 10px 0px 0px 10px;
}
.right-button {
	border-radius: 0px 10px 10px 0px;
}

.only-button {
	border-radius: 10px;
}

.tab-title {
	font-size: 14px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);
}

.tab-description {
	font-size: 12px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);
}
.info-icon {
	&:hover {
		::v-deep path {
			stroke: var(--primary-font-color);
		}
		::v-deep circle {
			stroke: var(--primary-font-color);
		}
	}
}

.placeholder-container {
	width: 18px;
	height: 18px;
}
</style>
